<template>
  <div class="login-container min-container">
    <div class="login-wrap" v-if="!$store.state.hasToken" :style="`background-image: url('${theme.background_url || bg}');`">
      <h2>{{theme.name || '全国青少年编程能力测评系统'}}</h2>
      <div class="form-box">
        <login-default v-if="site_msg.loginType === 1" @success="handleLoginNext"></login-default>
        <login-identity v-else-if="site_msg.loginType === 2" @success="handleLoginNext"></login-identity>
        <login-signid v-else-if="site_msg.loginType === 3" @success="handleLoginNext"></login-signid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginDefault from '@/components/Login/LoginDefault'
import LoginIdentity from '@/components/Login/LoginIdentity'
import LoginSignid from '@/components/Login/LoginSignid'
import { get, post } from '@/utils/ajax'
import { getTouristsVal } from '@/utils'
import { loginEvent } from '@/utils/sensor'

export default {
  components: {
    LoginDefault,
    LoginIdentity,
    LoginSignid
  },
  data () {
    return {
      bg: 'https://public-static-edu.codemao.cn/test/login.png'
    }
  },
  computed: {
    ...mapState(['user', 'theme', 'testInfo', 'site_msg'])
  },
  watch: {
    // 返回不会生效
    '$store.state.hasToken' (n, o) {
      if (n && this.$store.state.user.id && !this.testInfo.exam_id) {
        this.getTestInfo()
      }
    }
  },
  methods: {
    async handleLoginNext(userInfo) {
      localStorage.examId = ''
      this.$store.commit('HAS_TOKEN', true)
      this.$store.commit('SET_USER', userInfo)
      localStorage.setItem('user_id', userInfo.id)
      loginEvent(userInfo)
      // 加逻辑判断自动排考
      await this.goAutomatic()
      await this.getTestInfo()
    },
    async goAutomatic () {
      if (this.theme.is_automatic && !this.theme.arrange) {
        await post('/home/sites/auto/arrange', { address: location.origin + '/' + location.href.split('/')[3], name: this.user.fullname || localStorage.currentAccount || this.user.nickname, userId: this.user.id })
      }
    },
    async getTestInfo () {
      let siteId = ''
      if (this.theme.id) {
        siteId = `&site_id=${this.theme.id}`
      }
      let id = this.user.id
      if (!this.user.id) {
        const userInfo = await this.$auth('get_profile')
        id = userInfo.id
      }
      try {
        const { exam_id, only_exam, identity_verification, exam_config } = await get(`/home/edu/examinees/${id}/check/only?exam_type=2${siteId}`)
        if (!only_exam) { // 多场考试
          this.$router.push({ name: 'list' })
        } else {
          const examNoticeConfig = exam_config.find(item =>
            item.label === 'LARGE_EXAM#exam_notice'
          )
          const openExamNotice = examNoticeConfig && examNoticeConfig.actual_value === '1'
          if (this.theme.deviceCheckOpen || identity_verification === 1 || openExamNotice) { // 若这场考试需要设备检测/身份核验/考前须知，到列表页
            this.$router.push({ name: 'list' })
          } else { // 否则直接进入考试候考页
            localStorage.examId = exam_id
            this.$message.success('你有一场待参加的考试即将转入……')
            setTimeout(() => {
              this.$router.push({ name: 'pretest', query: { examId: exam_id } })
            }, 2000)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async mounted () {
    const isTourists = getTouristsVal()
    if (isTourists) {
      this.$router.push({ name: 'list' })
    }
    // 返回生效
    if (!this.user && this.$store.state.hasToken) {
      await this.$store.dispatch('getCodemaoUserInfo')
    }
    if (this.$store.state.hasToken && !this.$store.state.route.params.goLogin) {
      await this.getTestInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-color: $backgroundColor;
  display: flex;
  align-items: center;
}
.login-wrap {
  width: 1160px;
  height: 600px;
  border-radius: 8px;
  box-shadow: 0 0 30px 0 rgba(57, 126, 253, .1);
  margin: 0 auto;
  padding: 68px 0 0 520px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 520px 600px;
  h2 {
    margin-bottom: 60px;
    text-align: center;
  }
  .form-box {
    width: 360px;
    margin: 0 auto;
  }
}
</style>
